import React from 'react'
import { Stepper, Step, StepButton } from '@material-ui/core'
import styled from '@emotion/styled'

const fontFamily = "'IBM Plex Sans Thai', sans-serif"

const CreateStepper = styled(Stepper)({
  fontFamily,

  '.MuiStepButton-root, .MuiStepLabel-label, .MuiStepIcon-text': {
    fontFamily: `${fontFamily} !important`,
    fontSize: '12px'
  },

  '.MuiStepLabel-label': {
    fontWeight: 500,
  },
})

export default class CreateStep extends React.Component {
  render() {
    const { activeStep, maxStep, setFormStep } = this.props

    const handleStep = (step, maxStep, setFormStep) => {
      if (step <= maxStep) {
        setFormStep(step)
      }
    }

    return (
      <CreateStepper nonLinear activeStep={activeStep}>
        <Step>
          <StepButton
            completed={activeStep >= 1}
            // onClick={() => handleStep(1, maxStep, setFormStep)}
            style={{ cursor: 'default' }}
          >
            Category
          </StepButton>
        </Step>
        <Step>
          <StepButton
            completed={activeStep >= 2}
            onClick={() => handleStep(2, maxStep, setFormStep)}>
            General Information
          </StepButton>
        </Step>
        <Step>
          <StepButton
            completed={activeStep >= 3}
            onClick={() => handleStep(3, maxStep, setFormStep)}>
            Items
          </StepButton>
        </Step>
        <Step>
          <StepButton
            completed={activeStep >= 4}
            onClick={() => handleStep(4, maxStep, setFormStep)}>
            Attachment
          </StepButton>
        </Step>
        <Step>
          <StepButton
            completed={activeStep >= 5}
            onClick={() => handleStep(5, maxStep, setFormStep)}>
            Review and Submit
          </StepButton>
        </Step>
      </CreateStepper>
    )
  }
}
